import { NavLink } from "react-router-dom";

export const Link = ({
  route,
  underline = false,
  hover = true,
  children,
  end = true,
}) => {
  return (
    <NavLink
      to={route}
      end={end}
      className={({ isActive }) => {
        let style = "";
        if (isActive) {
          if (underline) {
            style = "border-b-2 border-white";
          } else {
            style = style + "bg-white bg-opacity-50";
          }
        }
        return style;
      }}
    >
      {children}
    </NavLink>
  );
};
